import React from 'react';
import Header from '../../sections/Header';
import Footer from '../../sections/Footer';
import Banner from '../../sections/Banner';
import Breadcrumbs from '../../sections/Breadcrumbs';

const companies = [
  {
    name: 'Microsoft',
    logo: '/logos/Microsoft-64.png',
    headline: 'Rolling out Copilot across M365, Teams, Azure AI, and Windows—now with local support for Australian government and enterprise clients.',
    why: 'Microsoft is embedded in nearly every enterprise tech stack in Australia. Their AI offerings—especially Copilot and Azure AI services—are the most immediate and trusted pathway for our clients to explore AI use cases. ai-Lab should be ready to guide safe, high-value adoption.',
    links: [
      { label: 'Microsoft Copilot for Microsoft 365', href: 'https://www.microsoft.com/en-us/microsoft-365/copilot' },
      { label: 'Azure OpenAI Service', href: 'https://azure.microsoft.com/en-us/products/ai-services/openai-service' },
      { label: 'Microsoft AI Cloud Partner Program', href: 'https://partner.microsoft.com/en-us/solutions/ai' },
    ],
  },
  {
    name: 'Google',
    logo: '/logos/Google-64.png',
    headline: 'Gemini-powered AI Overviews and enterprise tools now launched in Australia, with strong government partnerships and local infrastructure investment.',
    why: "Google's AI tools are changing how people search, work, and build—especially in retail, government, and telco. Many of our clients are impacted by shifts to SEO, workplace productivity, and cloud infrastructure. ai-Lab can help them navigate this ecosystem intelligently.",
    links: [
      { label: 'Gemini for Google Workspace', href: 'https://workspace.google.com/intl/en_au/gemini/' },
      { label: 'AI Overviews in Google Search', href: 'https://blog.google/products/search/ai-overviews-expand-more-users/' },
      { label: 'Google Cloud AI Solutions', href: 'https://cloud.google.com/ai' },
    ],
  },
  {
    name: 'Salesforce',
    logo: '/logos/Salesforce-64.png',
    headline: 'Einstein GPT and Agentforce introduce advanced AI across Sales, Service, and Marketing Cloud, now expanding into industry-specific use cases.',
    why: 'Salesforce is entrenched in CX, service, and CRM platforms across Australia. Their AI agents promise automation and insights, but implementation risks remain. ai-Lab should play an advisory role in driving safe, integrated, and customer-aligned use.',
    links: [
      { label: 'Salesforce Einstein 1 Overview', href: 'https://www.salesforce.com/artificial-intelligence/' },
      { label: 'Einstein Copilot (Product Guide)', href: 'https://www.salesforce.com/blog/einstein-copilot-ai-assistant/' },
      { label: 'AI-Powered Customer Service with Agentforce', href: 'https://www.salesforce.com/news/stories/salesforce-introduces-agentforce/' },
    ],
  },
  {
    name: 'IBM',
    logo: '/logos/IBM-64.png',
    headline: 'Watsonx.ai is positioning itself as the enterprise-safe gen-AI studio for hybrid cloud and regulated sectors, with governance and transparency features front and center.',
    why: "IBM's brand carries weight in regulated industries (finance, health, government). For clients needing AI with auditability, explainability, or risk controls, IBM offers a path. ai-Lab can support with evaluation, integration, or vendor-neutral advice.",
    links: [
      { label: 'watsonx.ai Overview', href: 'https://www.ibm.com/products/watsonx-ai' },
      { label: 'IBM AI Governance', href: 'https://www.ibm.com/products/watsonx-governance' },
      { label: 'IBM Consulting: Generative AI Services', href: 'https://www.ibm.com/consulting' },
    ],
  },
  {
    name: 'Anthropic',
    logo: '/logos/Anthropic_logo_64.png',
    headline: 'Claude 3.5 family now live, offering powerful reasoning, lightweight deployment, and early enterprise traction in the U.S. and Australia.',
    why: 'Anthropic offers a compelling alternative for clients focused on safety, transparency, and lightweight integration. Their investor base (Google, Amazon, Salesforce) is a signal of serious backing. ai-Lab can evaluate where Claude might fit in future architectures.',
    links: [
      { label: 'Claude by Anthropic', href: 'https://www.anthropic.com/index/claude' },
      { label: 'Claude API Documentation', href: 'https://aws.amazon.com/bedrock/' },
      { label: 'Claude 3.5 Model Update', href: 'https://www.anthropic.com/news/claude-3-5-sonnet' },
    ],
  },
  {
    name: 'AWS',
    logo: '/logos/AWS-64.png',
    headline: 'AWS remains the largest cloud provider in Australia.',
    why: "Their Bedrock platform supports foundation models from Anthropic, Meta, Cohere, and others, giving clients a highly flexible, 'bring your own model' approach. Enterprise relevance: Many Australian enterprises host their core infrastructure on AWS; Bedrock and Amazon Q (their new AI assistant) may become their default entry point into AI.",
    links: [
      { label: 'AWS Bedrock', href: 'https://aws.amazon.com/bedrock/' },
    ],
  },
  {
    name: 'Meta',
    logo: '/logos/meta-64.png',
    headline: "Meta's Llama 3 models are open-source, increasingly performant, and already being embedded into tools like Hugging Face, AWS, and Microsoft Azure.",
    why: "Enterprise relevance: As open-source AI gains traction for privacy-conscious clients, Meta's ecosystem could underpin cost-effective, controllable AI solutions.",
    links: [
      { label: 'Meta Llama 3', href: 'https://ai.meta.com/llama/' },
    ],
  },
  {
    name: 'Adobe',
    logo: '/logos/Adobe-64.png',
    headline: 'Adobe is embedding Firefly (generative imagery) and Sensei (AI-powered insights) across its entire Creative Cloud and Experience Cloud suite.',
    why: "If you work with clients in marketing, CX, or content, Adobe's AI suite will affect how they brief, build, and personalise experiences.",
    links: [
      { label: 'Adobe Firefly', href: '#' },
    ],
  },
  {
    name: 'ServiceNow',
    logo: '/logos/ServiceNow-64.png',
    headline: 'TBC',
    why: 'TBC',
    links: [
      { label: 'TBC', href: '#' },
    ],
  },
  {
    name: 'Oracle',
    logo: '/logos/Oracle-64.png',
    headline: 'TBC',
    why: 'TBC',
    links: [
      { label: 'TBC', href: '#' },
    ],
  },
];

const EcosystemPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      <Banner
        title="Ecosystem Watch"
        subtitle="As AI reshapes the consulting and digital production landscape, trusted technology brands like Microsoft, Google, and Salesforce are rapidly rolling out AI offerings—many tailored specifically for the Australian enterprise market. For (i.e.,), this matters deeply: our clients are high-profile, risk-aware organisations who will look first to their existing technology partners for AI innovation. This page exists to help us track what these major players are doing, with a focus on solutions relevant to our market."
        colorVariant="gradient"
        paddingVariant="default"
        breadcrumbs={<Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Initiatives', href: '/initiatives' }, { label: 'Ecosystem Watch' }]} />}
        icon={
          <div className="flex items-center justify-center w-full h-full">
            <img src="/logos/Ecosystem.svg" alt="Ecosystem Graphic" className="w-full h-64 object-contain" />
          </div>
        }
      />

      {/* Watch List Section */}
      <main className="flex-1 w-full bg-white">
        <section className="max-w-7xl mx-auto px-4 py-12">
          <h2 className="text-2xl md:text-3xl font-bold mb-6 text-gray-900">The watch list</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {companies.map((company, idx) => (
              <div key={company.name} className="border border-gray-200 rounded-lg bg-white p-6 flex flex-col gap-4 shadow-sm">
                <div className="flex items-center gap-4 mb-2">
                  <img src={company.logo} alt={company.name + ' logo'} className="h-10 w-10 object-contain" />
                  <span className="text-xl font-semibold text-gray-900">{company.name}</span>
                </div>
                <div>
                  <div className="font-semibold mb-1 text-gray-900">Latest headline</div>
                  <div className="text-gray-900 mb-4 text-base">{company.headline}</div>
                  <div className="font-semibold mb-1 text-gray-900">Why it matters</div>
                  <div className="text-gray-900 mb-4 text-base">{company.why}</div>
                  <div className="font-semibold mb-1 text-gray-900">Further reading</div>
                  <ul className="list-disc list-inside space-y-1">
                    {company.links.map((link, i) => (
                      <li key={i}>
                        <a href={link.href} className="text-blue-700 underline hover:text-blue-900" target="_blank" rel="noopener noreferrer">{link.label}</a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default EcosystemPage; 